import { initializeApp } from "firebase/app";

import { getFirestore } from "firebase/firestore";

import { getAuth } from "firebase/auth";

import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAs4iX2K0FOy3V0d5wnyP-v0vr4oS7ysic",
  authDomain: "lakdawalaeyehospital-f9656.firebaseapp.com",
  projectId: "lakdawalaeyehospital-f9656",
  storageBucket: "lakdawalaeyehospital-f9656.firebasestorage.app",
  messagingSenderId: "611431406166",
  appId: "1:611431406166:web:e8bf8beb19f189e41279f7",
  measurementId: "G-1PX1BR17SG",
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { db, auth };
export const storage = getStorage(app);
